import bannerImage from "../../assets/images/category-banners/sweatshirts.png";

export default {
  h1Text: `Нанесение логотипа на свитшот online`,
  h2Text: ``,
  regularTextHtml: `
  <h3>Прямая цифровая печать на свитшотах от 1 шт.<br>Создай свой дизайн.</h3>
  <p>Свитер это одновременно культовый и один из самых комфортных видов верхней одежды. Мы можем нанести любой принт на свитшот. Так же, в нашем магазине вы найдете креативные свитшоты с надписями и рисунками. Ваш креатив и наша печать способны создать действительно уникальную вещь, которая придется вам по вкусу и займет в вашем гардеробе достойное место! Печать на свитшоте это модно!
  </p>
  `,
  buttonText: `Выбрать свитшот`,
  image: [bannerImage]
};
